/**
 * Wokiee Shopify Theme - المحسن للأداء 2026
 * تم استبدال الـ Scroll Events بـ IntersectionObserver لزيادة السرعة
 */

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form && this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // تحسين الاستجابة البصرية الفورية
        requestAnimationFrame(() => {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          const spinner = this.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.remove('hidden');
        });

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            const spinner = this.querySelector('.loading-overlay__spinner');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

/**
 * Sticky Cart - نسخة محسنة باستخدام IntersectionObserver
 * توفر في استهلاك المعالج وتضمن تمرير سلس
 */
class stickyCartModal extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.button = this.querySelector('.sticky-cart-button');
    if (this.button) {
      this.button.addEventListener('click', this.onClickHandler.bind(this));
    }
    
    // تأخير بسيط للتأكد من رندر العناصر الأصلية
    setTimeout(() => this.initObserver(), 500);
  }

  initObserver() { const getBox = () => document.getElementById('product-container') || document.getElementById('product-form-' + this.dataset.section); const footer = document.querySelector('footer, .footer, .shopify-section-group-footer-group'); let ticking = false; const update = () => { ticking = false; const box = getBox(); if (!box) return; const passed = box.getBoundingClientRect().bottom < 0; const atFooter = footer && footer.getBoundingClientRect().top < window.innerHeight; const show = passed && !atFooter; this.classList.toggle('show-modal', show); document.body.classList.toggle('modal__sticky-cart', show); }; const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }; window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll); update(); }
  
  onClickHandler(e) {
    if (e) e.preventDefault();
    const variantSelectors = document.querySelector(`[id*="variant-selects-${this.dataset.section}"]`) || 
                             document.getElementById("product-container");
    
    if (variantSelectors) {
      variantSelectors.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
}
customElements.define('sticky-cart-modal', stickyCartModal);
